function deepSort(input: any): any {
  if (Array.isArray(input)) {
    return input.map(deepSort);
  } else if (
    input &&
    typeof input === 'object' &&
    input.constructor === Object
  ) {
    return Object.keys(input)
      .sort()
      .reduce<Record<string, unknown>>((sortedObj, key) => {
        sortedObj[key] = deepSort(input[key]);
        return sortedObj;
      }, {});
  }
  return input;
}

/**
 * Deeply sorts object properties and serializes the object as a JSON string.
 *
 * @param obj - The object to be sorted and serialized.
 * @returns A JSON string with sorted object properties.
 */
export function getObjectStableKey(obj: any): string {
  const sortedObject = deepSort(obj);
  return JSON.stringify(sortedObject);
}
